import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse } from 'antd';
import { RoleCard } from 'widgets/roles-info/ui/RoleCard/RoleCard';
import { RolesContainerStyled } from 'widgets/roles-info/ui/RolesInfo/RolesInfo.styles';

import { pxToRem } from 'shared/lib/pxToRem';
import { MpBlock } from 'shared/ui/MpBlock';
import { MpText } from 'shared/ui/MpText';
import { MpTitle } from 'shared/ui/MpTitle';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const RolesInfo = forwardRef<HTMLElement>((_, ref) => {
	const { t } = useTranslation();

	return (
		<MpBlock ref={ref} style={{ marginBottom: pxToRem(36) }}>
			<MpTitle level={2}>{t(`Marketplace_Role_Access`)}</MpTitle>
			<RolesContainerStyled>
				<RoleCard
					inModal={false}
					heading={t(`Marketplace_Department_Administrator`)}
					subheading={t(`Marketplace_All_Management`)}
					features={[
						t(`Marketplace_App_Connection_and_Usage`),
						t(`Marketplace_Subscription_for_App`),
						t(`Marketplace_Subscription_Management`),
						t(`Marketplace_Invoice_Tracking`),
					]}
				/>
				<RoleCard
					inModal={false}
					heading={t(`Marketplace_Office_Manager`)}
					subheading={t(`Marketplace_Usage_Only`)}
					features={[
						t(`Marketplace_Free_App_Connection_and_Usage`),
						t(`Marketplace_App_Connection_and_Usage_with_Paid_Subscription_by_Administrator_Subdivision`),
						t(`Marketplace_View_Subscription_Status`),
					]}
				/>
			</RolesContainerStyled>
			{/* <MpParagraph style={{ marginBottom: `12px` }}>{t(`Marketplace_App_User_Unlimited`)}</MpParagraph> */}
			<Collapse ghost style={{ padding: `0` }}>
				<Collapse.Panel key='1' header={<MpText size={16}>{t(`Marketplace_Example_How_It_Works`)}</MpText>}>
					<MpText style={{ padding: `0 16px` }}>{t(`Marketplace_Subscription_Usage_Example`)}</MpText>
				</Collapse.Panel>
			</Collapse>
		</MpBlock>
	);
});
